<template>
  <div class="flex flex-row gap-3 p-2">
    <div class="flex-col text-right w-1/6 uppercase text-blue-500 text-lg" :class="caclulateClassLabel()">{{ label }}</div>
    <div class="flex-col text-md w-3/4 text-left border-solid border-l-2 pl-2 align-text-bottom" :class="caclulateClass()">
      <a class="text-blue-500" v-if="link" :href="link">{{ value }}</a>
      <div v-else>{{ value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourceInfoItem',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    featured: {
      type: Boolean,
      required: true,
    },
    link: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    function caclulateClassLabel() {
      if (props.featured) {
        return 'font-medium text-lg'
      }
      return 'font-thin text-md'
    }

    function caclulateClass() {
      if (props.featured) {
        return 'font-medium text-lg text-blue-700'
      }
      return 'font-thin text-gray-700'
    }
    return { caclulateClass, caclulateClassLabel }
  },
}
</script>

<style scoped>

</style>
